<template>
  <el-dialog
    class="gift-list-dialog"
    :visible.sync="visible"
    title="贈送記錄"
    :modal-append-to-body="false"
  >
    <div class="gift-list-box">
      <ul class="gift-list" v-loadMore="getList" v-if="visible">
        <li
          v-for="(item, index) of pageList"
          :key="index"
          class="gift-list-item"
        >
          {{
            `您在${getSourceName(item.giftFrom)}贈送了${item.giftCount}個${
              item.giftName
            }給${item.playerNickname}`
          }}
        </li>
      </ul>
    </div>
  </el-dialog>
</template>
<script>
export default {
  name: 'GiveGiftList',
  props: {},
  data() {
    return {
      visible: false,
      pageList: [],
      // 查询参数
      pageEventParams: {
        sendGiftRecord: true,
        pageIndex: 0,
        pageSize: 10,
        giftIds: [133]
      },
      pageTotal: null
    };
  },
  watch: {},
  computed: {},
  methods: {
    // 获取跳转页面配置
    async getList() {
      try {
        if (
          this.pageEventParams.pageIndex === null ||
          this.pageList.length < this.pageTotal
        ) {
          if (this.pageEventParams.pageIndex === null) {
            this.pageEventParams.pageIndex = 0;
          } else {
            this.pageEventParams.pageIndex += 1;
          }
          const { data } = await this.$http.post(
            '/gift/search',
            this.pageEventParams
          );
          if (!data) {
            this.pageList = this.pageList || [];
            return;
          }
          this.pageList = this.pageList.concat(data.pageContent) || [];
          this.pageTotal = data.totalRemain;
        }
      } catch (error) {
        if (this.pageEventParams.pageIndex === 0) {
          this.pageEventParams.pageIndex = null;
        } else {
          this.pageEventParams.pageIndex -= 1;
        }
        console.log(error);
      }
    },
    // 獲取活動來源
    getSourceName(source) {
      if (source === 'NORMAL') {
        return '私訊中';
      }
      if (source === 'VOICE_ROOM') {
        return '語音房内';
      }
      if (source === 'ACTIVITY') {
        return '活動中';
      }
    },
    openDialog() {
      this.visible = true;
      this.initList();
    },
    closeDialog() {
      this.visible = false;
    },
    // 初始化列表
    initList() {
      this.pageEventParams = {
        sendGiftRecord: true,
        pageIndex: null,
        pageSize: 10,
        giftIds: [133]
      };
      this.pageList = [];
      this.pageTotal = null;
      this.getList();
    }
  }
};
</script>
<style lang="scss">
.gift-list-dialog {
  overflow: visible;
   .el-dialog {
    border-radius: 14px;
    max-width: 400px;
  }
  .el-dialog__body {
    padding: 20px;
  }
  .el-dialog__header {
    text-align: center;
  }
  .el-dialog__footer {
    display: none;
  }
  .gift-list-box {
    position: relative;
    height: 400px;
    .gift-list {
      overflow: auto;
      height: 100%;
    }
    .gift-list-item {
      padding-bottom: 30px;
    }
  }
}
</style>
